import {
    useCallback, useEffect, useReducer,
} from 'react';

const LOCAL_STORAGE_KEY = 'layout';

type LayoutState = Record<string, unknown>;
type Action = { type: 'setData'; payload: LayoutState };

const initialState: LayoutState = {
    clientName: '',
    clientAge: undefined,
    risk: '',
    isCorrectFlow: false,
    disabled: false,
};

const reducer = (state: LayoutState = initialState, action: Action): LayoutState => {
    switch (action.type) {
        case 'setData':
            return { ...state, ...action.payload };
        default:
            return state;
    }
};

export const useLayout = () => {
    const [state, dispatch] = useReducer(reducer, JSON.parse(sessionStorage.getItem(LOCAL_STORAGE_KEY) || 'null') || initialState);
    const setData = useCallback((layoutData: LayoutState) => {
        dispatch({ type: 'setData', payload: layoutData });
    }, []);

    const clearLayoutCache = useCallback(() => {
        sessionStorage.removeItem(LOCAL_STORAGE_KEY);
    }, []);

    const goto = useCallback((step: number) => {
        setData({ stepNavBarActive: step });
    }, [setData]);

    const setPageErrors = useCallback((errors: unknown) => {
        setData({ pageErrors: errors });
    }, [setData]);

    useEffect(() => {
        sessionStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(state));
    }, [state]);

    return {
        data: state,
        setData,
        goto,
        setPageErrors,
        clearLayoutCache,
    };
};
